export * from '../../components/Page/Navigation';
export * from '../../components/Page/Page';
export { pageTransparentBgCss } from '../../components/Page/Page.styled';
export * from '../../components/Page/ScrollSnapContainer';
